import React from 'react';
import Logo from '@wix/da-ds/pkg/Logo';
import { useTranslation } from 'react-i18next';
import { Url, URLS } from '@wix/da-url';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import { BiData } from '@wix/da-bi/pkg/events';
import Burger from '../_partials/Burger';
import SearchIconButton from './_partials/SearchIconButton';
import SubmitButton from '../../SiteHeader/SiteHeaderMobile/SubmitDropdown';
import UserMenuButton from '../../SiteHeader/SiteHeaderMobile/UserMenu';
import ChatButtonAndDropdown from '../../SiteHeader/SiteHeaderDesktop/ChatButtonAndDropdown.new_site_header';
import NotificationsDropdownWrapper from '../../SiteHeader/SiteHeaderDesktop/NotificationsDropdownWrapper.new_site_header';
import s from './SiteHeaderMobile.scss';
var SiteHeaderMobile = function (_a) {
    var showNetworkBar = _a.showNetworkBar, isLegacyHeader = _a.isLegacyHeader, isLoggedIn = _a.isLoggedIn, isUserDropdownOpen = _a.isUserDropdownOpen, closeNotificationsDropdown = _a.closeNotificationsDropdown;
    var t = useTranslation().t;
    return (React.createElement("div", { className: s['root'] },
        React.createElement("div", { className: s['left-zone'] },
            React.createElement(Burger, { showNetworkBar: showNetworkBar, iconClassName: s['icon'] }),
            React.createElement(BiLink, { biData: BiData({
                    evid: 700,
                    link_url: Url.buildFromPath(URLS.ROOT),
                    link_name: 'logo',
                }), href: Url.buildFromPath(URLS.ROOT), "aria-label": t('siteHeader.a11y.home'), className: s['logo-link'] },
                React.createElement(Logo, { size: "tiny", withText: false })),
            isLoggedIn && (React.createElement(React.Fragment, null,
                React.createElement(NotificationsDropdownWrapper, { iconClassName: s['icon'], numberClassName: s['number'], isLegacyHeader: isLegacyHeader }),
                React.createElement(ChatButtonAndDropdown, { iconClassName: s['icon'], numberClassName: s['number'], disableDropdown: isLegacyHeader }))),
            React.createElement(SearchIconButton, { className: s['icon'] })),
        React.createElement("div", { className: s['right-zone'] },
            React.createElement(UserMenuButton, { isOpen: isUserDropdownOpen, onOpen: closeNotificationsDropdown, hideNotificationCount: true, isLegacyHeader: isLegacyHeader }),
            React.createElement(SubmitButton, { className: s['submit-button'], menuClassName: s['submit-menu'], isLegacyHeader: isLegacyHeader }))));
};
SiteHeaderMobile.displayName = 'SiteHeaderMobile';
export default SiteHeaderMobile;
//# sourceMappingURL=SiteHeaderMobile.js.map